/** Auth / password routes that use the legacy full-width shell (no app chrome) */
const NEIGHBORS_AUTH_ROUTE_PREFIXES = [
    '/login',
    '/forgot-password',
    '/change-forgotten-password',
    '/welcome',
] as const;

export function normalizeNeighborsPath(pathname: string): string {
    return pathname.replace(/\/+$/, '') || '/';
}

/** Signed-in app routes (home, calendar, messages, etc.) — not login/auth pages */
export function isNeighborsAuthenticatedAppRoute(pathname: string): boolean {
    const normalized = normalizeNeighborsPath(pathname);
    const isNeighborsOrMembers = process.env.REACT_APP_PLATFORM === 'neighbors' || process.env.REACT_APP_PLATFORM === 'members';
    return isNeighborsOrMembers && !NEIGHBORS_AUTH_ROUTE_PREFIXES.some(
        (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`),
    );
}